import { render, staticRenderFns } from "./timedsalegoodsdetail.vue?vue&type=template&id=2a298a8a&scoped=true&"
import script from "./timedsalegoodsdetail.vue?vue&type=script&lang=js&"
export * from "./timedsalegoodsdetail.vue?vue&type=script&lang=js&"
import style0 from "./timedsalegoodsdetail.vue?vue&type=style&index=0&id=2a298a8a&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a298a8a",
  null
  
)

export default component.exports